import { render } from "./Parcours.vue?vue&type=template&id=55566726&scoped=true"
import script from "./Parcours.vue?vue&type=script&lang=js"
export * from "./Parcours.vue?vue&type=script&lang=js"

import "./Parcours.vue?vue&type=style&index=0&id=55566726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55566726"]])

export default __exports__